var React = require('react');
var h = React.createElement;

var VALID_SEVERITIES = { urgent: true, warning: true, info: true };

function normalizeSeverity(value) {
  var s = String(value || '').toLowerCase().trim();
  if (VALID_SEVERITIES[s]) return s;
  if (s === 'blocker' || s === 'critical' || s === 'high' || s === 'error') return 'urgent';
  if (s === 'medium' || s === 'minor-blocker' || s === 'warn') return 'warning';
  if (s === 'low' || s === 'minor' || s === 'note') return 'info';
  return 'warning';
}

function extractIdFromLabel(label) {
  var s = String(label || '');
  var m = s.match(/id=([^\s)]+)/);
  return m ? m[1] : null;
}

function normalizeLocators(f) {
  var out = [];
  if (Array.isArray(f.locators)) {
    f.locators.forEach(function(loc) {
      if (!loc) return;
      if (typeof loc === 'string') {
        var s = loc.trim();
        if (s) out.push({ label: s, nodeId: extractIdFromLabel(s) });
        return;
      }
      var label = String(loc.label || '').trim();
      var nodeId = loc.nodeId ? String(loc.nodeId).trim() : extractIdFromLabel(label);
      if (label || nodeId) out.push({ label: label || ('id=' + nodeId), nodeId: nodeId || null });
    });
  }
  if (out.length === 0 && f.locator) {
    var legacy = String(f.locator).trim();
    if (legacy) out.push({ label: legacy, nodeId: extractIdFromLabel(legacy) });
  }
  return out;
}

function parseFindings(text) {
  var raw = String(text || '');
  var match = raw.match(/<findings>([\s\S]*?)<\/findings>/i);
  if (!match) return null;
  var inner = match[1].trim();
  if (!inner) return [];
  try {
    var parsed = JSON.parse(inner);
    if (!Array.isArray(parsed)) return null;
    return parsed
      .filter(function(f) { return f && (f.title || f.body); })
      .map(function(f) {
        var bodyText = String(f.body || '').trim();
        var fixText = String(f.fix || '').trim();
        if (!fixText && bodyText) {
          var split = splitBodyAndFix(bodyText);
          bodyText = split.body;
          fixText = split.fix;
        }
        return {
          severity: normalizeSeverity(f.severity),
          title: String(f.title || '').trim(),
          body: bodyText,
          fix: fixText,
          locators: normalizeLocators(f)
        };
      });
  } catch (e) {
    return null;
  }
}

function SeverityIcon(props) {
  var severity = props.severity;
  var common = {
    width: 16, height: 16, viewBox: '0 0 24 24',
    fill: 'none', stroke: 'currentColor',
    strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round'
  };
  if (severity === 'urgent') {
    return h('svg', common,
      h('circle', { cx: 12, cy: 12, r: 10 }),
      h('line', { x1: 12, y1: 8, x2: 12, y2: 12 }),
      h('line', { x1: 12, y1: 16, x2: 12.01, y2: 16 })
    );
  }
  if (severity === 'info') {
    return h('svg', common,
      h('circle', { cx: 12, cy: 12, r: 10 }),
      h('line', { x1: 12, y1: 16, x2: 12, y2: 12 }),
      h('line', { x1: 12, y1: 8, x2: 12.01, y2: 8 })
    );
  }
  return h('svg', common,
    h('path', { d: 'M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z' }),
    h('line', { x1: 12, y1: 9, x2: 12, y2: 13 }),
    h('line', { x1: 12, y1: 17, x2: 12.01, y2: 17 })
  );
}

var SEVERITY_LABEL = { urgent: 'Urgent', warning: 'Non-blocker', info: 'Info' };

function splitBodyAndFix(body) {
  var text = String(body || '');
  // Match "Fix:" either at start-of-line OR preceded by sentence-ending punctuation,
  // so models that write the fix inline ("...bad reporting. Fix: open node...") also work.
  var m = text.match(/(^|\n|[.!?]\s+)(Fix:\s*[\s\S]+)$/);
  if (!m) return { body: text.trim(), fix: '' };
  var fix = m[2].replace(/^Fix:\s*/, '').trim();
  var prefix = m[1] || '';
  var splitAt = m.index + (prefix === '\n' || prefix === '' ? prefix.length : prefix.length);
  var rest = text.slice(0, splitAt).trim();
  return { body: rest, fix: fix };
}

function LocatorChip(props) {
  var loc = props.loc;
  var onLocate = props.onLocate;
  var canLocate = !!(loc.nodeId && onLocate);
  var label = loc.label || (loc.nodeId ? 'id=' + loc.nodeId : '');
  if (!label) return null;
  return h(canLocate ? 'button' : 'span', {
    type: canLocate ? 'button' : undefined,
    className: 'log-chat-finding-chip' + (canLocate ? ' log-chat-finding-chip-clickable' : ''),
    onClick: canLocate ? function() { onLocate(loc.nodeId); } : undefined,
    title: canLocate ? 'Jump to this node' : undefined
  },
    h('svg', {
      className: 'log-chat-finding-chip-icon',
      width: 11, height: 11, viewBox: '0 0 24 24',
      fill: 'none', stroke: 'currentColor',
      strokeWidth: 2.2, strokeLinecap: 'round', strokeLinejoin: 'round'
    },
      h('path', { d: 'M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z' }),
      h('circle', { cx: 12, cy: 10, r: 3 })
    ),
    h('span', { className: 'log-chat-finding-chip-label' }, label)
  );
}

function buildFixMessage(finding) {
  var lines = [];
  if (finding.title) lines.push(finding.title);
  if (finding.body) lines.push('', finding.body);
  if (finding.fix) lines.push('', 'Suggested fix: ' + finding.fix);
  var locators = Array.isArray(finding.locators) ? finding.locators : [];
  if (locators.length) {
    var refs = locators.map(function(l) { return l.label; }).filter(Boolean);
    if (refs.length) lines.push('', 'Affected nodes: ' + refs.join(', '));
  }
  return lines.join('\n').trim();
}

function FindingCard(props) {
  var finding = props.finding;
  var onDismiss = props.onDismiss;
  var onLocate = props.onLocate;
  var onFix = props.onFix;
  var severity = finding.severity || 'warning';
  var locators = Array.isArray(finding.locators) ? finding.locators : [];
  var fixNodeId = locators.length && locators[0].nodeId ? locators[0].nodeId : null;
  var canFix = !!(fixNodeId && onFix);
  return h('div', { className: 'log-chat-finding log-chat-finding-' + severity },
    h('div', { className: 'log-chat-finding-head' },
      h('span', {
        className: 'log-chat-finding-icon',
        title: SEVERITY_LABEL[severity] || severity,
        'aria-label': SEVERITY_LABEL[severity] || severity
      }, h(SeverityIcon, { severity: severity })),
      h('div', { className: 'log-chat-finding-title' }, finding.title),
      onDismiss ? h('button', {
        type: 'button',
        className: 'log-chat-finding-dismiss',
        onClick: onDismiss,
        title: 'Dismiss'
      }, 'Dismiss') : null
    ),
    finding.body ? h('div', { className: 'log-chat-finding-body' }, finding.body) : null,
    finding.fix ? h('div', { className: 'log-chat-finding-fix' },
      h('span', { className: 'log-chat-finding-fix-label' }, 'Fix'),
      h('span', { className: 'log-chat-finding-fix-text' }, finding.fix)
    ) : null,
    (locators.length || canFix) ? h('div', { className: 'log-chat-finding-actions' },
      h('div', { className: 'log-chat-finding-locators' },
        locators.map(function(loc, i) {
          return h(LocatorChip, { key: i, loc: loc, onLocate: onLocate });
        })
      ),
      canFix ? h('button', {
        type: 'button',
        className: 'log-chat-finding-fix-btn',
        onClick: function() { onFix(fixNodeId, buildFixMessage(finding)); },
        title: 'Open this node in AskCode with the issue pre-loaded'
      },
        h('svg', {
          width: 12, height: 12, viewBox: '0 0 24 24',
          fill: 'none', stroke: 'currentColor',
          strokeWidth: 2.2, strokeLinecap: 'round', strokeLinejoin: 'round'
        },
          h('path', { d: 'M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z' })
        ),
        h('span', null, 'Fix with AskCode')
      ) : null
    ) : null
  );
}

function LogChatFindings(props) {
  var findings = Array.isArray(props.findings) ? props.findings : [];
  var dismissed = props.dismissed || {};
  var onDismiss = props.onDismiss || function() {};
  var onLocate = props.onLocate || null;
  var onFix = props.onFix || null;
  var visible = findings.filter(function(_f, i) { return !dismissed[i]; });
  if (!findings.length) {
    return h('div', { className: 'log-chat-findings-empty' }, 'No issues found.');
  }
  return h('div', { className: 'log-chat-findings' },
    visible.map(function(f, i) {
      var originalIndex = findings.indexOf(f);
      return h(FindingCard, {
        key: originalIndex,
        finding: f,
        onDismiss: function() { onDismiss(originalIndex); },
        onLocate: onLocate,
        onFix: onFix
      });
    }),
    h('div', { className: 'log-chat-findings-footer' },
      visible.length + ' finding' + (visible.length === 1 ? '' : 's')
    )
  );
}

module.exports = {
  parseFindings: parseFindings,
  LogChatFindings: LogChatFindings
};
